<app-title-bar titleText="i18n.base.login.header"></app-title-bar>
<div class="login-wrapper d-flex">
  <img class="login_logo" src="../../../assets/img/logo.svg">
  <div>
    <h2>{{"i18n.base.login.select-login-title" | translate}}</h2>
    <div class="login-mode-selector">
      <div>
        <button class="btn btn-secondary login-mode-selector-item stargate-button" (click)="selectLocalLogin()">
        </button>
        <div class="button-description">
          <h4>{{ "i18n.base.login.stargate-user" | translate }}</h4>
        </div>
      </div>
      <div>
        <button class="btn btn-secondary login-mode-selector-item littlebit-button" (click)="selectSamlLogin()">
        </button>
        <div class="button-description">
          <h4>{{ "i18n.base.login.littlebit-user" | translate }}</h4>
        </div>
      </div>
    </div>
  </div>
</div>
